/**
 * Decimal.js Global Configuration
 * This file MUST be imported first in main.tsx to ensure
 * the configuration is applied before any other module uses Decimal
 */
import Decimal from "decimal.js";

/**
 * Configure Decimal.js for German locale and consistent precision
 * - precision: 30 significant digits (handles large numbers like energy conversions)
 * - rounding: ROUND_HALF_UP (standard rounding)
 * - toExpNeg/toExpPos: Controls when exponential notation is used
 */
Decimal.set({
  precision: 30,
  rounding: Decimal.ROUND_HALF_UP,
  toExpNeg: -7,
  toExpPos: 30,
});

// Re-export Decimal so other modules can use the configured instance
export { Decimal };
export const ZERO = new Decimal(0);
